import { render, staticRenderFns } from "./ProductLink.vue?vue&type=template&id=db6f687c&scoped=true&"
import script from "./ProductLink.vue?vue&type=script&lang=ts&"
export * from "./ProductLink.vue?vue&type=script&lang=ts&"
import style0 from "./ProductLink.vue?vue&type=style&index=0&id=db6f687c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6f687c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
